/**
 * Approval chains offered ready-made. One click creates the workflow with
 * every step; the card shows exactly what the click will make.
 */

import { stepSummary } from './stepText';
import { WORKFLOW_EXAMPLES, type WorkflowExample } from './exampleChains';
import styles from '../../shared/Page.module.css';
import own from './Approvals.module.css';

interface Props {
  /** The key being created, so only that button says so and the rest wait. */
  creating: string | null;
  onCreate: (example: WorkflowExample) => void;
}

export function WorkflowExamples({ creating, onCreate }: Props) {
  return (
    <ul className={own.examples} aria-label="Example workflows">
      {WORKFLOW_EXAMPLES.map((ex) => (
        <li key={ex.key} className={own.example}>
          <h3 className={own.exampleName}>{ex.name}</h3>
          <p className={own.exampleSuits}>{ex.suits}</p>
          <ol className={own.exampleSteps}>
            {ex.steps.map((step, i) => (
              <li key={step.name}>
                <span className={own.exampleOrder} aria-hidden="true">{i + 1}</span>
                <span>
                  {step.name}
                  <span className={own.exampleRole}> · {stepSummary(step, []).join(' · ')}</span>
                </span>
              </li>
            ))}
          </ol>
          <p className={own.exampleWhy}>{ex.description}</p>
          {ex.basis && <p className={own.exampleBasis}>{ex.basis}</p>}
          <button
            type="button"
            className={styles.btn}
            disabled={creating !== null}
            aria-label={`Create the workflow "${ex.name}"`}
            onClick={() => onCreate(ex)}
          >
            {creating === ex.key ? 'Creating…' : 'Create this workflow'}
          </button>
        </li>
      ))}
    </ul>
  );
}
